import { TextZoom, TextZoomPlugin } from '@capacitor/text-zoom';

type TextZoomApi = Partial<Pick<TextZoomPlugin, 'set'>> & Pick<TextZoomPlugin, 'getPreferred'>;

type StyleWriter = {
	style: {
		setProperty: (property: string, value: string) => void;
	};
};

type TextZoomDocument = {
	body: StyleWriter | null;
	documentElement: StyleWriter;
};

export const DEFAULT_TEXT_ZOOM_VALUE = 1;

const applyTextSizeAdjustFallback = (documentReference: TextZoomDocument, zoomValue: number): void => {
	const textSizeAdjustInPercent = `${String(Math.round(zoomValue * 100))}%`;

	documentReference.documentElement.style.setProperty('text-size-adjust', textSizeAdjustInPercent);
	documentReference.documentElement.style.setProperty('-webkit-text-size-adjust', textSizeAdjustInPercent);

	if (documentReference.body !== null) {
		documentReference.body.style.setProperty('text-size-adjust', textSizeAdjustInPercent);
		documentReference.body.style.setProperty('-webkit-text-size-adjust', textSizeAdjustInPercent);
	}
};

export const syncPreferredTextZoom = async (
	textZoomApi: TextZoomApi = TextZoom,
	documentReference: TextZoomDocument | null = typeof document === 'undefined' ? null : document
): Promise<boolean> => {
	try {
		await textZoomApi.getPreferred();
		const zoomValue = DEFAULT_TEXT_ZOOM_VALUE;

		if (textZoomApi.set !== undefined) {
			try {
				await textZoomApi.set({ value: zoomValue });
				return true;
			} catch {
				// Fallback is needed on platforms where native set() is not implemented.
			}
		}

		if (documentReference !== null) {
			applyTextSizeAdjustFallback(documentReference, zoomValue);
		}

		return true;
	} catch {
		return false;
	}
};
